import { useIntl } from 'react-intl'

export default function useLocaleMode() {
    const { locale } = useIntl();
    const localePath = locale + '/';
    return { localePath, locale }
}